import { render, staticRenderFns } from "./Demonstrations.vue?vue&type=template&id=de142702&scoped=true&"
import script from "./Demonstrations.vue?vue&type=script&lang=js&"
export * from "./Demonstrations.vue?vue&type=script&lang=js&"
import style0 from "./Demonstrations.vue?vue&type=style&index=0&id=de142702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de142702",
  null
  
)

export default component.exports